// package
import { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
    Card,
    Col,
    Row,
    Form,
} from "react-bootstrap";
import Select from "react-select";

// component
import AgStatus from "elements/System/AgStatus";
import { api, common } from "includes";

export default function NotificationPreference(props: any) {

    // state
    const [process, setProcess] = useState<any>({ result: 100 });
    const [resultList, setResultList] = useState<any>(null);
    const [selectedUserLocality, setSelectedUserLocality] = useState<any>();
    const [selectedIncType, setSelectedIncType] = useState<any>();
    const [selectedUnit, setSelectedUnit] = useState<any>();
    const [selectedLoc, setSelectedLoc] = useState<any>();
    const [selectedSubLoc, setSelectedSubLoc] = useState<any>();

    // effect
    useEffect(() => {
        processState("result", 100);
        getNotifications();
    }, []);


    // api 
    const getNotifications = () => {
        let data: any = {
            url: `admin/notification/preference/${props.userId}`,
            method: "GET",
        };
        api.call(
            data,
            (res: any) => {
                processState("result", res.status)
                if (res.status === 200) {
                    let result = res.data.data;
                    setResultList(result);

                }
            }
        );
    };

    //events
    const removeNotification = (e: any, id: any) => {
        e.preventDefault();
        let param = {
            url: `admin/notification/preference/${id}`,
            method: "delete"
        };

        api.call(
            param,
            (res: any) => {
                if (res.status === 200) {
                    common.notify("S", "Preference removed successfully");
                    getNotifications();
                } else {
                    common.notify("E", res?.data.error);
                }
            }
        );

    }

    const addNotification = (e: any, type: string) => {
        e.preventDefault();
        let notId: any = null;
        switch (type) {
            case "incidentType":
                notId = selectedIncType?._id;
                break;
            case "unit":
                notId = selectedUnit?._id;
                break;
            case "locality":
                notId = selectedLoc?._id;
                break;
            case "subLocality":
                notId = selectedSubLoc?._id;
                break;
        }
        if (notId) {
            let param = {
                url: `admin/notification/preference/add`,
                method: "POST",
                body: {
                    userId: props.userId,
                    notificationId: notId,
                    type: type
                },
            };

            api.call(
                param,
                (res: any) => {
                    if (res.status === 200) {
                        common.notify("S", "Preference added successfully");
                        getNotifications();
                    } else {
                        common.notify("E", res?.data.error);
                    }
                }
            );
        } else {
            common.notify("E", "No value selected");
        }
    }

    const subscribeLocality = (e: any,) => {
        e.preventDefault();
        let param = {
            url: `admin/userlocality/subscribe`,
            method: "POST",
            body: {
                userId: props.userId,
                localityId: selectedUserLocality?.locality?._id,
                subLocalityId: selectedUserLocality._id
            },
        };

        api.call(
            param,
            (res: any) => {
                if (res.status === 200) {
                    common.notify("S", "Locality added successfully");
                    getNotifications();
                } else {
                    common.notify("E", res?.data.error);
                }
            }
        );
    }

    const unsubscribeLocality = (e: any, obj: any) => {
        e.preventDefault();
        let param = {
            url: `admin/userlocality/unsubscribe`,
            method: "DELETE",
            body: {
                userId: props.userId,
                localityId: obj?.localityId?._id,
                subLocalityId: obj?.subLocalityId?._id
            },
        };

        api.call(
            param,
            (res: any) => {
                if (res.status === 200) {
                    common.notify("S", "Locality removed successfully");
                    getNotifications();
                } else {
                    common.notify("E", res?.data.error);
                }
            }
        );
    }

    // callback
    const onAgCallBack = (status: any) => {
        getNotifications();
    };

    // support
    const processState = (label: any, value: any) => {
        setProcess((prev: any) => ({
            ...prev,
            [label]: value
        }));
    }

    const getLabel = (notiId: any, type: string) => {
        if (type == "incidentType") {
            let filtered = resultList.distinct.incidentType.filter((obj: any) => obj._id == notiId)
            return filtered.length > 0 ? filtered[0].optionName + ", " + filtered[0].locality?.name : "";
        } else if (type == "unit") {
            let filtered = resultList.distinct.unit.filter((obj: any) => obj._id == notiId)
            return filtered.length > 0 ? filtered[0].unitName : "";
        } else if (type == "locality") {
            let filtered = resultList.distinct.locality.filter((obj: any) => obj._id == notiId)
            return filtered.length > 0 ? filtered[0].name : "";
        } else if (type == "subLocality") {
            let filtered = resultList.distinct.subLocality.filter((obj: any) => obj._id == notiId)
            return filtered.length > 0 ? filtered[0].name : "";
        }
    }
    return (
        <Fragment>
            {process.result != 200 ? (
                <AgStatus
                    process={process.result}
                    message={{
                        100: "Loading... Please wait!",
                        404: "Something went wrong! Please Refresh Again",
                    }}
                    button={{ 400: "Refresh", 404: "Refresh" }}
                    size="l"
                    onAgCallBack={onAgCallBack}
                />
            ) : (
                <Row>
                    <Col>
                        <Card>
                            <Card.Body>
                                <h5 className="mb-3 text-uppercase bg-light p-2">
                                    <i className="ri-map-pin-line me-1" /> Followed Localities
                                </h5>
                                <Row>
                                    <Col md={5}>
                                        <Form.Group className="mb-3">
                                            <div className="d-flex align-items-center">
                                                <Select
                                                    className="select2 z-5 w-100"
                                                    classNamePrefix="react-select"
                                                    options={resultList.distinct.subLocality}
                                                    onChange={(data) => setSelectedUserLocality(data)}
                                                    getOptionLabel={(option: any) => option.name + ", " + option.locality.name}
                                                    getOptionValue={(option: any) => option._id + "," + option.locality._id}
                                                />
                                                <Link
                                                    to="#"
                                                    onClick={(e: any) => subscribeLocality(e)}
                                                    className="btn btn-success ms-2 flex-shrink-0"
                                                >
                                                    <i className="ri-add-line" /> Add
                                                </Link>
                                            </div>
                                        </Form.Group>
                                        <ul className="list-group list-group-flush">
                                            {resultList.followedLocality?.map((loc: any, idx: number) => (
                                                <li className="list-unstyled mb-1" key={idx}>
                                                    <Link to="#" className="btn btn-danger btn-sm me-2" onClick={(e: any) => unsubscribeLocality(e, loc)}>
                                                        <i className="ri-subtract-line" />
                                                    </Link>
                                                    <span>{loc?.localityId?.name}, {loc?.subLocalityId?.name}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                        <Card>
                            <Card.Body>
                                <h5 className="mb-2 text-uppercase bg-light p-2">
                                    <i className="ri-map-pin-line me-1" /> Notification Preference
                                </h5>
                                <Row>
                                    <Col md={5}>
                                        <Form.Label>Incident Type</Form.Label>
                                        <Form.Group className="mb-3">
                                            <div className="d-flex align-items-center">
                                                <Select
                                                    className="select2 z-5 w-100"
                                                    classNamePrefix="react-select"
                                                    options={resultList.distinct.incidentType}
                                                    onChange={(data) => setSelectedIncType(data)}
                                                    getOptionLabel={(option: any) => option.optionName + " @ " + option.locality.name}
                                                    getOptionValue={(option: any) => option.optionName + "," + option.locality._id}
                                                />
                                                <Link
                                                    to="#"
                                                    onClick={(e: any) => addNotification(e, "incidentType")}
                                                    className="btn btn-success ms-2 flex-shrink-0"
                                                >
                                                    <i className="ri-add-line" /> Add
                                                </Link>
                                            </div>
                                        </Form.Group>
                                        <ul className="list-group list-group-flush">
                                            {resultList.user?.incidentType?.map((type: any, idx: number) => (
                                                <li className="list-unstyled mb-1" key={idx}>
                                                    <Link to="#" className="btn btn-danger btn-sm me-2" onClick={(e: any) => removeNotification(e, type._id)}>
                                                        <i className="ri-subtract-line" />
                                                    </Link>
                                                    <span>{getLabel(type?.notificationId, "incidentType",)}</span>
                                                </li>
                                            ))}
                                        </ul>

                                        <Form.Label className="mt-3">Sub Localities</Form.Label>
                                        <Form.Group className="mb-3">
                                            <div className="d-flex align-items-center">
                                                <Select
                                                    className="select2 z-5 w-100"
                                                    classNamePrefix="react-select"
                                                    options={resultList.distinct.subLocality}
                                                    onChange={(data) => setSelectedSubLoc(data)}
                                                    getOptionLabel={(option: any) => option.name + " in " + option.locality.name}
                                                    getOptionValue={(option: any) => option._id + "," + option.locality._id}
                                                // getOptionLabel={(option: any) => option.name}
                                                // getOptionValue={(option: any) => option._id + "," + option.locality._id}
                                                />
                                                <Link
                                                    to="#"
                                                    onClick={(e: any) => addNotification(e, "subLocality")}
                                                    className="btn btn-success ms-2 flex-shrink-0"
                                                >
                                                    <i className="ri-add-line" /> Add
                                                </Link>
                                            </div>
                                        </Form.Group>
                                        <ul className="list-group list-group-flush">
                                            {resultList.user?.subLocality?.map((subLoc: any, idx: number) => (
                                                <li className="list-unstyled mb-1" key={idx}>
                                                    <Link to="#" className="btn btn-danger btn-sm me-2" onClick={(e: any) => removeNotification(e, subLoc._id)}>
                                                        <i className="ri-subtract-line" />
                                                    </Link>
                                                    <span>{getLabel(subLoc?.notificationId, "subLocality",)}</span>
                                                </li>
                                            ))}
                                        </ul>

                                        <Form.Label className="mt-3">Unit</Form.Label>
                                        <Form.Group className="mb-3">
                                            <div className="d-flex align-items-center">
                                                <Select
                                                    className="select2 z-5 w-100"
                                                    classNamePrefix="react-select"
                                                    options={resultList.distinct.unit}
                                                    onChange={(data) => setSelectedUnit(data)}
                                                    getOptionLabel={(option: any) => option.unitName}
                                                    getOptionValue={(option: any) => option._id}
                                                />
                                                <Link
                                                    to="#"
                                                    onClick={(e: any) => addNotification(e, "unit")}
                                                    className="btn btn-success ms-2 flex-shrink-0"
                                                >
                                                    <i className="ri-add-line" /> Add
                                                </Link>
                                            </div>
                                        </Form.Group>
                                        <ul className="list-group list-group-flush">
                                            {resultList.user?.unit?.map((unit: any, idx: number) => (
                                                <li className="list-unstyled mb-1" key={idx}>
                                                    <Link to="#" className="btn btn-danger btn-sm me-2" onClick={(e: any) => removeNotification(e, unit._id)}>
                                                        <i className="ri-subtract-line" />
                                                    </Link>
                                                    <span>{getLabel(unit?.notificationId, "unit",)}</span>
                                                </li>
                                            ))}
                                        </ul>

                                        <Form.Label className="mt-3">Locality</Form.Label>
                                        <Form.Group className="mb-3">
                                            <div className="d-flex align-items-center">
                                                <Select
                                                    className="select2 z-5 w-100"
                                                    classNamePrefix="react-select"
                                                    options={resultList.distinct.locality}
                                                    onChange={(data) => setSelectedLoc(data)}
                                                    getOptionLabel={(option: any) => option.name}
                                                    getOptionValue={(option: any) => option._id}
                                                />
                                                <Link
                                                    to="#"
                                                    onClick={(e: any) => addNotification(e, "locality")}
                                                    className="btn btn-success ms-2 flex-shrink-0"
                                                >
                                                    <i className="ri-add-line" /> Add
                                                </Link>
                                            </div>
                                        </Form.Group>
                                        <ul className="list-group list-group-flush">
                                            {resultList.user?.locality?.map((loc: any, idx: number) => (
                                                <li className="list-unstyled mb-1" key={idx}>
                                                    <Link to="#" className="btn btn-danger btn-sm me-2" onClick={(e: any) => removeNotification(e, loc._id)}>
                                                        <i className="ri-subtract-line" />
                                                    </Link>
                                                    <span>{getLabel(loc?.notificationId, "locality",)}</span>
                                                </li>
                                            ))}
                                        </ul>

                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            )}
        </Fragment>
    );
}

